<template>
    <section class="m-industry-part">
        <h2 id="m_blk1" class="u-hello nav_choose">
            {{qsName}}，
            <span>你好！</span>
        </h2>
        <p class="u-industry-title1">金麒麟最佳分析师参选行业如下：</p>
        <div class="m-industry-box1">
            <span
                v-for="(item ,index) in tagsArr"
                :key="item.id"
                :class="['u-industry-btn',item.sub_flag == 1 ? 'choose' : '', active == index ? 'selected' : '']"
                :data-id="item.id"
                :data-des="item.desc"
                @click="getLists(index,$event)"
            >{{item.name}}</span>
        </div>
        <div class="m-industry-box2">
            <div class="m-industry-des1">
                <p
                    v-for="item in explain"
                    :key="item.id"
                    class="u-industry-des1"
                >{{item.num}}、{{item.des}}</p>
            </div>
            <div>
                <div class="m-industry-title2">
                    <h2>
                        {{industry}}
                        <span v-if="industryDesc">（说明：{{industryDesc}}）</span>
                    </h2>
                    <!-- <label class="m-industry-label1">
                        参选
                        <el-checkbox v-model="checked"></el-checkbox>
                    </label>-->
                </div>
                <div class="m-industry-title3">
                    <h3>团队情况</h3>
                </div>
                <div class="m-industry-label1">
                    <div class="clearfix">
                        <label class="fl">
                            <span class="u-industry-name1">首席分析师：</span>
                            <div class="m-industry-input1">
                                <el-input placeholder="请输入内容" v-model="form.chair_name" clearable></el-input>
                            </div>
                        </label>

                        <label class="fl">
                            <span class="u-industry-name2">从业年限：</span>
                            <div class="m-industry-input3">
                                <el-input placeholder="请输入内容" v-model="form.chair_time" clearable></el-input>
                                <!-- <el-input-number
                                v-model="form.chair_time"
                                controls-position="right"
                                :precision="2"
                                :min="1"
                                :max="60"
                                ></el-input-number>&nbsp;年-->
                            </div>&nbsp;年
                        </label>
                    </div>
                    <p
                        class="u-industry-des2"
                    >注：该团队首席获得执业资格年限，如从业4年11月，请填写4.11，同时若该行业有多名首席，姓名、从业年限需用“、”隔开。</p>
                    <!-- <label class="m-industry-label1 fr">
                        <span class="u-industry-name1">联系方式：</span>
                        <div class="m-industry-input1">
                            <el-input placeholder="请输入内容" v-model="form.chair_name" clearable></el-input>
                        </div>
                    </label>-->
                </div>
                <label class="m-industry-label1">
                    <span class="u-industry-name1">联系方式：</span>
                    <div class="m-industry-input2">
                        <el-input placeholder="首席分析师的联系方式" v-model="form.chair_tele" clearable></el-input>
                    </div>
                </label>
                <label class="m-industry-label1">
                    <span class="u-industry-name1">团队成员：</span>
                    <div class="m-industry-input2">
                        <el-input placeholder="请输入内容" v-model="form.team_name" clearable></el-input>
                    </div>
                    <p class="u-industry-des2">注释：团队成员名字间隔请用“、”顿号。</p>
                </label>
                <div class="m-industry-title3">
                    <h3>研报情况</h3>
                </div>
                <label class="m-industry-label1">
                    <span class="u-industry-name3">近一年研报数量（2018年9月30日-2019年9月30日）：</span>
                    <el-input-number
                        v-model="form.report_num"
                        controls-position="right"
                        :step="1"
                        :max="100000"
                    ></el-input-number>&nbsp;篇
                </label>
                <label class="m-industry-label1">
                    <span class="u-industry-name1">主要研报：</span>
                    <div class="m-industry-input2">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 4, maxRows: 4}"
                            placeholder="请输入内容"
                            v-model="form.report_brief"
                        ></el-input>
                    </div>
                    <p class="u-industry-des2">注释：指2018年9月30日至2019年9月30日期间，撰写的5篇优秀研报题目清单，包含作者、日期、题目。</p>
                </label>
                <div class="m-industry-box3">
                    <a class="u-industry-btn2 fl" href="javascript:;" @click="postApply">提交</a>
                    <a
                        :class="['u-industry-btn2','fr',!isPrint ? 'unclick' : '']"
                        href="javascript:;"
                        @click="jumpAbout"
                    >预览</a>
                    <!-- <router-link
                        :to="[!isPrint ?'javascript:;':'/about']"
                        :class="['u-industry-btn2','fr',!isPrint ? '' : 'unclick']"
                    >预览</router-link>-->
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "industry",
    data() {
        return {
            explain: pageDatas.industryDatas.explain,
            tagsArr: {},
            active: 0,
            qsName: "",
            industry: "",
            industryDesc: "",
            form: {
                chair_name: "",
                chair_time: 1,
                chair_tele: "",
                team_name: "",
                report_num: 1,
                report_brief: ""
            },
            isPrint: 0
        };
    },
    created() {
        this.getTags();
    },
    methods: {
        getTags() {
            var _this = this;
            // console.log(sessionStorage.getItem("acode") );
            let param = {
                url:
                    "//support.finance.sina.com.cn/service/api/openapi.php/JinQiService.getConfList",
                acode: sessionStorage.getItem("acode")
                    ? sessionStorage.getItem("acode")
                    : "",
                atype: "qs",
                type: "hy"
            };
            // console.log(param);
            // 发送 POST 请求
            this.$jsonp(param.url, {
                acode: param.acode,
                atype: param.atype,
                type: param.type
            })
                .then(function(response) {
                    // console.log(response);
                    if (response.result.status.code == 0) {
                        let datas = response.result.data;
                        _this.tagsArr = datas;
                        let cur = _this.active ||0;
                        _this.getLists(cur);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        getLists(index, ele) {
            var _this = this;
            var el = ele ? ele.currentTarget : "";
            _this.industry = el ? el.textContent : "宏观经济";
            // console.log(el);
            _this.industryDesc = el ? el.dataset.des : "";

            _this.active = index;
            let param = {
                url:
                    "//support.finance.sina.com.cn/service/api/openapi.php/JinQiService.getQsInfo",
                // ?acode=ajzq_020235f9c2af&atype=qs&hy_id=1
                acode: sessionStorage.getItem("acode")
                    ? sessionStorage.getItem("acode")
                    : "",
                atype: "qs",
                hy_id: index + 1
            };
            // 发送 POST 请求
            this.$jsonp(param.url, {
                acode: param.acode,
                atype: param.atype,
                hy_id: param.hy_id
            })
                .then(function(response) {
                    // console.log(response);
                    if (response.result.status.code == 0) {
                        let datas = response.result.data;
                        let adapterDatas = _this.adapter(datas.hy)[0];
                        _this.form = adapterDatas;
                        _this.qsName = datas.qs.name;
                        _this.isPrint = datas.qs.hy_total;
                        // console.log("list", _this.isPrint);
                        // _this.industry = adapterDatas.hy_name;
                        // console.log(datas.hy[0]);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        adapter(data) {
            if (!data.length) {
                return [
                    {
                        chair_name: "",
                        chair_time: 1,
                        chair_tele: "",
                        team_name: "",
                        report_num: 1,
                        report_brief: ""
                    }
                ];
            }
            return data.reduce(function(per, cur) {
                per.push({
                    chair_name: cur.chair_name || "",
                    chair_time: cur.chair_time || "",
                    chair_tele: cur.chair_tele || "",
                    team_name: cur.team_name || "",
                    report_num: Number(cur.report_num) || 1,
                    report_brief: cur.report_brief || "",
                    hy_name: cur.hy_name || ""
                });

                return per;
            }, []);
        },
        postApply() {
            // 发送 POST 请求
            var _this = this;
            let url =
                "//support.finance.sina.com.cn/service/api/openapi.php/JinQiService.saveQsInfo";
            let param = new URLSearchParams();
            param.append("acode", sessionStorage.getItem("acode"));
            param.append("atype", "qs");
            param.append("hy_id", this.active + 1);
            param.append("chair_name", this.form.chair_name);
            param.append("chair_time", this.form.chair_time);
            param.append("chair_tele", this.form.chair_tele);
            param.append("team_name", this.form.team_name);
            param.append("report_num", this.form.report_num);
            param.append("report_brief", this.form.report_brief);
            this.axios({
                method: "POST",
                url: url,
                data: param
            })
                .then(function(response) {
                    // console.log(response);
                    let data = response.data.result;
                    if (data.status.code == 0) {
                        // let msg = data.status.msg;
                        //  console.log(msg);
                        _this.$message({
                            message:
                                "恭喜你，报名成功！请填写其他行业报名或预览填写内容！",
                            type: "success"
                        });
                        _this.getTags();
                    } else {
                        let msg = data.status.msg;
                        _this.$message({
                            message: msg,
                            type: "warning"
                        });
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        jumpAbout() {
            if (!this.isPrint) {
                return;
            }
            this.$confirm(
                "请提交当前填写内容后预览，预览内容为所有参选行业报名情况！",
                "提示",
                {
                    distinguishCancelAndClose: true,
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }
            )
                .then(() => {
                    this.$router.push({ path: "about" });
                })
                .catch(() => {
                    // this.$message({
                    //     type: "info",
                    //     message: "已取消删除"
                    // });
                });
            // console.log("1", this.isPrint);
            // if (!this.isPrint) {
            //     return;
            // }
            // this.$router.push({ path: "about" });
        }
    }
};
</script>

<style >
</style>
